import {Skeleton, Stack} from '@mui/material';
import {EmptySearchState, MainFooter, MainHeader, PageWrapperLayout} from 'presentation/components';
import {SubscriptionDialogs} from 'presentation/components/SubscriptionDialogs';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {NotificationCard} from '../../components/NotificationCard';
import {useNotifications} from '../../hooks/useNotifications';
import {StyledBox} from './styles';
import {RegistrationDataDrawer} from 'presentation/pages/private/home/components';

const {notifications} = translations['pt-br'].commons;
const {empty} = translations['pt-br'].privateFlow.notifications;

export function Notifications() {
	const {isMobile} = useMediaQueries();

	const {
		notificationsList,
		handleBack,
		isLoading,
		isLoadingYears,
		isSubmittingSubscription,
		currentEmail,
		protocol,
		handleSubscriptionResponse,
		handleCloseSubscriptionSucessModal,
		handleToggleShowInfoModal,
		handleToggleSubscriptionModal,
		setOperationSubscriptionState,
		isNotificationsEmpty,
		handleCloseRegistrationDataDrawer,
		showRegistrationDataDrawer,
	} = useNotifications();

	const shouldShowEmptyState = isNotificationsEmpty && !isLoading && !isLoadingYears;

	return (
		<PageWrapperLayout title={notifications}>
			<MainHeader
				hideClose
				handleBack={handleBack}
				variant="subRoute"
				title={notifications}
			/>

			<Stack spacing={2} p={isMobile ? 2 : '16px 32px'}>
				{isLoading || isLoadingYears ? (
					<Fragment>
						<Skeleton sx={{transform: 'initial'}} height={128} />
						<Skeleton sx={{transform: 'initial'}} height={128} />
					</Fragment>
				) : (
					<Fragment>
						{notificationsList
							.filter(i => i.shouldShow)
							.map((notification, index) => (
								<NotificationCard key={index} {...notification} />
							))}
					</Fragment>
				)}

				{shouldShowEmptyState ? (
					<EmptySearchState
						customMaxWidthCard="100%"
						title={empty.title}
						description={empty.description}
					/>
				) : null}
			</Stack>

			<StyledBox mt="auto">
				<MainFooter customMarginBottom="40px" />
			</StyledBox>

			<SubscriptionDialogs
				isSubmitting={isSubmittingSubscription}
				onSubscriptionResponse={handleSubscriptionResponse}
				onCloseSubscriptionModal={() => handleToggleSubscriptionModal(false)}
				onCloseSubscriptionSucessModal={handleCloseSubscriptionSucessModal}
				onShowSubscriptionModal={() => handleToggleSubscriptionModal(true)}
				onCloseInfoModal={() => handleToggleShowInfoModal(false)}
				onShowInfoModal={() => handleToggleShowInfoModal(true)}
				currentEmail={currentEmail}
				protocol={protocol}
				setOperationState={setOperationSubscriptionState}
			/>

			<RegistrationDataDrawer
				open={showRegistrationDataDrawer}
				onClose={handleCloseRegistrationDataDrawer}
			/>
		</PageWrapperLayout>
	);
}
